import { format } from 'date-fns';
import styled from 'styled-components';

import DateRangeBadge from 'components/shared/DateRangeBadge';
import DesktopOnly from 'components/shared/responsiveness/DesktopOnly';
import MobileOnly from 'components/shared/responsiveness/MobileOnly';
import { END_DATE, START_DATE } from 'constants/filterKeysConstants';
import { useReferralsInsightsStore } from 'stores/referralsInsightsStore';
import { BodySmallBold } from 'styles/typography';

export default function ReferralHighlightsHeader() {
  const startDate = useReferralsInsightsStore((state) => state.filters[START_DATE]) as Date;
  const endDate = useReferralsInsightsStore((state) => state.filters[END_DATE]) as Date;

  return (
    <Header>
      <TitleGroup>
        <TitleColumn>
          <Title>Referral Highlights</Title>
          <MobileOnly>
            <Subtitle>
              {format(startDate, 'MM/dd/yyyy')} - {format(endDate, 'MM/dd/yyyy')}
            </Subtitle>
          </MobileOnly>
        </TitleColumn>
        <DesktopOnly>
          <DateRangeBadge startDate={startDate} endDate={endDate} />
        </DesktopOnly>
      </TitleGroup>
    </Header>
  );
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black10};
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black};
`;

const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 12px;
  font-weight: normal;
`;
